import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";

const FAQS = [
  {
    q: "How long does it take for my website to arrive?",
    a: "Timelines depend on the project scope and how quickly the required content is supplied. Smaller Launch builds are usually completed sooner, while Growth and Black Label projects require more design and development time. Your expected schedule will be confirmed before work begins.",
  },
  {
    q: "What do you need from me to get started?",
    a: "Just the basics — your business name, logo (if you have one), and a rough idea of what you want the website to do. We can help shape everything else, including wording and structure. If you already have photos or brand assets, great; if not, we'll guide you.",
  },
  {
    q: "Will my website work on phones and tablets?",
    a: "Absolutely. Every CLOSER. website is fully responsive and designed mobile-first — it will look and feel premium on phones, tablets, laptops and large desktop screens.",
  },
  {
    q: "I already have a website. Can you improve it?",
    a: "Yes — our website redesign service transforms outdated sites into modern digital experiences. We'll keep what's working, rebuild what isn't, and give your business a completely refreshed online presence.",
  },
  {
    q: "Can I update the website myself after it launches?",
    a: "For most content, yes. If you need a blog, news section or editable pages, this can be agreed and built into the project before development begins.",
  },
  {
    q: "Do I own my website?",
    a: "Yes. Once your project is complete and paid for, the agreed website, design and supplied content belong to you. Any third-party licences or subscriptions remain subject to their own terms.",
  },
  {
    q: "How does payment work?",
    a: "Projects are split into two simple payments: a deposit to secure your build slot, and the balance when your website is ready to launch. We'll always agree the full price upfront — no surprises.",
  },
  {
    q: "What happens after I approve the website?",
    a: "After final approval and payment, CLOSER. completes the agreed launch or handover. Future changes are not included in the original package and would need to be agreed as separate work.",
  },
];

const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative z-10 py-28 sm:py-36">
    <div className="mx-auto max-w-4xl px-6 sm:px-10">
      <SectionHeading
        kicker="FAQ"
        title="Questions, Answered."
        sub="Everything businesses usually ask before launching with us. Anything else — just ask."
        testId="faq-heading"
        align="center"
      />
      <Reveal i={2}>
        <Accordion type="single" collapsible className="mt-14 space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl glass border-white/10 px-6 sm:px-8 transition-[background-color,border-color] duration-300 data-[state=open]:bg-white/[0.06] data-[state=open]:border-white/25"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 sm:py-6 font-display text-base sm:text-lg font-medium tracking-tight text-white hover:no-underline hover:text-white/80 [&>svg]:text-white/50"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="text-sm sm:text-base font-light leading-relaxed text-white/55">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
